import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2c7021a1 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _712c85d8 = () => interopDefault(import('../pages/confirmation/index.vue' /* webpackChunkName: "pages/confirmation/index" */))
const _38fa5bd9 = () => interopDefault(import('../pages/payment/index.vue' /* webpackChunkName: "" */))
const _09f74f44 = () => interopDefault(import('../pages/curriculum/index.vue' /* webpackChunkName: "pages/curriculum/index" */))
const _0baa4862 = () => interopDefault(import('../pages/defaultHomeBlocks.ts' /* webpackChunkName: "pages/defaultHomeBlocks" */))
const _72d11710 = () => interopDefault(import('../pages/education.vue' /* webpackChunkName: "pages/education" */))
const _6be8c0fb = () => interopDefault(import('../pages/education/index.vue' /* webpackChunkName: "pages/education/index" */))
const _14ad412c = () => interopDefault(import('../pages/education/homeworks.vue' /* webpackChunkName: "pages/education/homeworks" */))
const _6f0f3d30 = () => interopDefault(import('../pages/education/mentor.vue' /* webpackChunkName: "pages/education/mentor" */))
const _007f7657 = () => interopDefault(import('../pages/education/questionnaires.vue' /* webpackChunkName: "pages/education/questionnaires" */))
const _dc3b9dec = () => interopDefault(import('../pages/education/settings.vue' /* webpackChunkName: "pages/education/settings" */))
const _40ccc0cc = () => interopDefault(import('../pages/education/trajectories.vue' /* webpackChunkName: "pages/education/trajectories" */))
const _55043c91 = () => interopDefault(import('../pages/education/mock/blocksMock.js' /* webpackChunkName: "pages/education/mock/blocksMock" */))
const _1d808cc0 = () => interopDefault(import('../pages/education/mock/educationMocks.js' /* webpackChunkName: "pages/education/mock/educationMocks" */))
const _753d062e = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _c3c5913e = () => interopDefault(import('../pages/feedbacks/index.vue' /* webpackChunkName: "pages/feedbacks/index" */))
const _f6ee33a8 = () => interopDefault(import('../pages/gu-education/index.vue' /* webpackChunkName: "pages/gu-education/index" */))
const _123828b9 = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _67dc277c = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _01ac5eed = () => interopDefault(import('../pages/logout/index.vue' /* webpackChunkName: "pages/logout/index" */))
const _1c54970e = () => interopDefault(import('../pages/notification/index.vue' /* webpackChunkName: "pages/notification/index" */))
const _81041180 = () => interopDefault(import('../pages/referral/index.vue' /* webpackChunkName: "pages/referral/index" */))
const _63841ac6 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _6107f326 = () => interopDefault(import('../pages/confirmation/new.vue' /* webpackChunkName: "pages/confirmation/new" */))
const _ea4efab2 = () => interopDefault(import('../pages/jobs/employer/index.vue' /* webpackChunkName: "pages/jobs/employer/index" */))
const _171a15c3 = () => interopDefault(import('../pages/jobs/vacancies/index.vue' /* webpackChunkName: "pages/jobs/vacancies/index" */))
const _747c975a = () => interopDefault(import('../pages/notification/settings/index.vue' /* webpackChunkName: "pages/notification/settings/index" */))
const _678b02ce = () => interopDefault(import('../pages/password/edit.vue' /* webpackChunkName: "pages/password/edit" */))
const _c08c00e8 = () => interopDefault(import('../pages/password/new.vue' /* webpackChunkName: "pages/password/new" */))
const _d075302e = () => interopDefault(import('../pages/teacher/homeworks/index.vue' /* webpackChunkName: "pages/teacher/homeworks/index" */))
const _7735c8f4 = () => interopDefault(import('../pages/teacher/new/index.vue' /* webpackChunkName: "pages/teacher/new/index" */))
const _0b750b65 = () => interopDefault(import('../pages/teacher/reports/index.vue' /* webpackChunkName: "pages/teacher/reports/index" */))
const _6828e999 = () => interopDefault(import('../pages/teacher/streams/index.vue' /* webpackChunkName: "pages/teacher/streams/index" */))
const _618126dc = () => interopDefault(import('../pages/teacher/streams/active/index.vue' /* webpackChunkName: "pages/teacher/streams/active/index" */))
const _000ad7d6 = () => interopDefault(import('../pages/teacher/streams/completed/index.vue' /* webpackChunkName: "pages/teacher/streams/completed/index" */))
const _99e326bc = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _06d1f212 = () => interopDefault(import('../pages/jobs/employer/_id/index.vue' /* webpackChunkName: "pages/jobs/employer/_id/index" */))
const _b8c6d1a4 = () => interopDefault(import('../pages/jobs/vacancies/_id/index.vue' /* webpackChunkName: "pages/jobs/vacancies/_id/index" */))
const _666a8bd2 = () => interopDefault(import('../pages/lessons_new/_id.vue' /* webpackChunkName: "pages/lessons_new/_id" */))
const _ae59d94c = () => interopDefault(import('../pages/lessons_new/_id/index.vue' /* webpackChunkName: "pages/lessons_new/_id/index" */))
const _6dfd5818 = () => interopDefault(import('../pages/lessons_new/_id/homework.vue' /* webpackChunkName: "pages/lessons_new/_id/homework" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/calendar",
    component: _2c7021a1,
    name: "calendar___ru"
  }, {
    path: "/confirmation",
    component: _712c85d8,
    name: "confirmation___ru"
  }, {
    path: "/consultation",
    component: _38fa5bd9,
    props: {"isConsultation":true},
    name: "consultation___ru"
  }, {
    path: "/curriculum",
    component: _09f74f44,
    name: "curriculum___ru"
  }, {
    path: "/defaultHomeBlocks",
    component: _0baa4862,
    name: "defaultHomeBlocks___ru"
  }, {
    path: "/education",
    component: _72d11710,
    children: [{
      path: "",
      component: _6be8c0fb,
      name: "education___ru"
    }, {
      path: "homeworks",
      component: _14ad412c,
      name: "education-homeworks___ru"
    }, {
      path: "mentor",
      component: _6f0f3d30,
      name: "education-mentor___ru"
    }, {
      path: "questionnaires",
      component: _007f7657,
      name: "education-questionnaires___ru"
    }, {
      path: "settings",
      component: _dc3b9dec,
      name: "education-settings___ru"
    }, {
      path: "trajectories",
      component: _40ccc0cc,
      name: "education-trajectories___ru"
    }, {
      path: "mock/blocksMock",
      component: _55043c91,
      name: "education-mock-blocksMock___ru"
    }, {
      path: "mock/educationMocks",
      component: _1d808cc0,
      name: "education-mock-educationMocks___ru"
    }]
  }, {
    path: "/faq",
    component: _753d062e,
    name: "faq___ru"
  }, {
    path: "/feedbacks",
    component: _c3c5913e,
    name: "feedbacks___ru"
  }, {
    path: "/gu-education",
    component: _f6ee33a8,
    name: "gu-education___ru"
  }, {
    path: "/jobs",
    component: _123828b9,
    name: "jobs___ru"
  }, {
    path: "/login",
    component: _67dc277c,
    name: "login___ru"
  }, {
    path: "/logout",
    component: _01ac5eed,
    name: "logout___ru"
  }, {
    path: "/notification",
    component: _1c54970e,
    name: "notification___ru"
  }, {
    path: "/payment",
    component: _38fa5bd9,
    name: "payment___ru"
  }, {
    path: "/referral",
    component: _81041180,
    name: "referral___ru"
  }, {
    path: "/register",
    component: _63841ac6,
    name: "register___ru"
  }, {
    path: "/confirmation/new",
    component: _6107f326,
    name: "confirmation-new___ru"
  }, {
    path: "/geek_university/edutrack",
    component: _f6ee33a8,
    name: "geek-university-education___ru"
  }, {
    path: "/jobs/employer",
    component: _ea4efab2,
    name: "jobs-employer___ru"
  }, {
    path: "/jobs/vacancies",
    component: _171a15c3,
    name: "jobs-vacancies___ru"
  }, {
    path: "/notification/settings",
    component: _747c975a,
    name: "notification-settings___ru"
  }, {
    path: "/password/edit",
    component: _678b02ce,
    name: "password-edit___ru"
  }, {
    path: "/password/new",
    component: _c08c00e8,
    name: "password-new___ru"
  }, {
    path: "/teacher/homeworks",
    component: _d075302e,
    name: "teacher-homeworks___ru"
  }, {
    path: "/teacher/new",
    component: _7735c8f4,
    name: "teacher-new___ru"
  }, {
    path: "/teacher/reports",
    component: _0b750b65,
    name: "teacher-reports___ru"
  }, {
    path: "/teacher/streams",
    component: _6828e999,
    name: "teacher-streams___ru"
  }, {
    path: "/teacher/streams/active",
    component: _618126dc,
    name: "teacher-streams-active___ru"
  }, {
    path: "/teacher/streams/completed",
    component: _000ad7d6,
    name: "teacher-streams-completed___ru"
  }, {
    path: "/",
    component: _99e326bc,
    name: "index___ru"
  }, {
    path: "/geek_university/edutrack/:id?",
    component: _09f74f44,
    name: "education-constructor___ru",
    beforeEnter: (to, from, next) => {
            const routes = ['it', 'design', 'marketing', 'management', 'geekschool', 'itnewline'];
            if (to.params.id && !routes.includes(to.params.id)) {
              next({
                path: '/geek_university/edutrack'
              });

              return;
            }
            next();
          }
  }, {
    path: "/jobs/employer/:id",
    component: _06d1f212,
    name: "jobs-employer-id___ru"
  }, {
    path: "/jobs/vacancies/:id",
    component: _b8c6d1a4,
    name: "jobs-vacancies-id___ru"
  }, {
    path: "/feedbacks/:type?",
    component: _c3c5913e,
    name: "gb-feedbacks___ru",
    beforeEnter: (to, from, next) => {
            const routes = ['it', 'design', 'marketing', 'management', 'geekclass'];
            if (to.params.type && !routes.includes(to.params.type)) {
              next({
                path: '/feedbacks'
              });

              return;
            }
            next();
          }
  }, {
    path: "/lessons_new/:id?",
    component: _666a8bd2,
    children: [{
      path: "",
      component: _ae59d94c,
      name: "lessons_new-id___ru"
    }, {
      path: "homework",
      component: _6dfd5818,
      name: "lessons_new-id-homework___ru"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
